import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Port1Graph from "./Port1GraphView";
import "../../css/Port1View.css";
import { Port1UpdatedTime } from "./Port1Slice";
import { useSelector } from "react-redux";

export type PeriodType = "累計" | "今月" | "先月";

const Port1 = () => {
  const [period, setPeriod] = useState<PeriodType>("今月");

  const ChangePeriod = (item: PeriodType) => {
    setPeriod(item);
  };

  const port1UpdatedTime = useSelector(Port1UpdatedTime);

  return (
    <div className="position_row">
      <div className="dashboard_container_port1">
        <h1 className="dashboard_title_port1">
          利用状況 -北区、西区、東区- ({period})
        </h1>
        <div className="button_container_port1">
          <button
            className="period_item_port1"
            onClick={() => ChangePeriod("累計")}>
            累計
          </button>
          <button
            className="period_item_port1"
            onClick={() => ChangePeriod("今月")}>
            今月
          </button>
          <button
            className="period_item_port1"
            onClick={() => ChangePeriod("先月")}>
            先月
          </button>
        </div>
        <div className="time_msg">※データは1分ごとに自動更新されます</div>
        <div className="dashbaord_time">最終更新時間 : {port1UpdatedTime}</div>
        <div className="graph_container_port1">
          <Port1Graph period={period} />
        </div>
      </div>
    </div>
  );
};

export default Port1;
